export default __webpack_public_path__ + "static/Online-Shopping-Experience-e19b011c554f967a20c5fc7d81460afc.webp";